<stby-icon
    icon="info"
    size="16"
    class="tooltip-icon"
    tabindex="0"
    aria-hidden="false"
    [matTooltip]="tooltip() | translate"
    [matTooltipPosition]="tooltipPosition()"
/>
